<template>
  <VSpacer>
    <slot />
  </VSpacer>
</template>

<script setup lang="ts">
import { VSpacer } from 'vuetify/components/VGrid';
</script>
